// Voicemail alerts in the CRM (FIX-AGENTS-2026-10-12 §7 / NIGHT-AGENTS-2026-10-14 step 1).
//
// * Every voicemail alert -- voicemail_received, and robocall (a misfiled robocall must still be audible) -- gets a
//   Play button. Play asks /api/voicemail-audio (the Pages Function: same origin + the signed-in session) which asks
//   the recruiter-agent Worker; the Worker fetches the audio with its own Twilio credentials. The browser receives
//   audio bytes and never a Twilio URL.
// * Rows written before 2026-10-14 carry "Recording: https://api.twilio.com/..." in their detail. The loader runs
//   every detail through stripTwilioUrls() before it reaches state, so no view can render one; the recording id that
//   URL named is kept (the same rewrite as recruiter-agent src/voicemail-audio.js).
// * The ?alert=<id> deep link (the last line of every staff SMS and email) lands on that row.
//
// PURE, like the other ./lib modules.

export const VOICEMAIL_REASON = 'voicemail_received';
export const ROBOCALL_REASON = 'robocall';

export function isVoicemailAlert(n) {
  const r = String((n && n.reason) || '');
  return r === VOICEMAIL_REASON || r === ROBOCALL_REASON;
}
export function isRobocallAlert(n) {
  return String((n && n.reason) || '') === ROBOCALL_REASON;
}

const RECORDING_SID = /\bRE[0-9a-f]{32}\b/;
const TWILIO_URL = /https?:\/\/[a-z0-9.-]*twilio\.com\/\S*/gi;

/** Every Twilio URL replaced by the recording id it names, else by a marker. Never throws; '' for null. */
export function stripTwilioUrls(text) {
  const sidOf = (url) => { const m = RECORDING_SID.exec(url); return m ? m[0] : ''; };
  return String(text == null ? '' : text)
    .replace(/Recording:\s*(https?:\/\/[a-z0-9.-]*twilio\.com\/\S*)/gi, (_, url) => (sidOf(url) ? `RecordingSid ${sidOf(url)}` : 'Recording on file'))
    .replace(TWILIO_URL, (url) => (sidOf(url) ? `RecordingSid ${sidOf(url)}` : '[link removed]'));
}

/** The loader's pass over agent_notifications rows: detail cleaned, nothing else touched. New array. */
export function cleanNotifications(rows) {
  return (Array.isArray(rows) ? rows : []).map((n) => (n && typeof n.detail === 'string' && /twilio\.com/i.test(n.detail)
    ? { ...n, detail: stripTwilioUrls(n.detail) } : n));
}

/** Robocall rows (any status), newest first: the System alerts "Spam (N)" list. */
export function robocallAlerts(notifications) {
  const ts = (n) => { const t = Date.parse(n && n.created_at); return Number.isFinite(t) ? t : 0; };
  return (notifications || []).filter(isRobocallAlert).slice().sort((a, b) => ts(b) - ts(a));
}

/** What a failed Play says, by the proxy's / Worker's error code. */
export const PLAY_ERRORS = {
  unauthorized: 'Your session expired — sign in again to play it.',
  no_recording: 'Twilio has no recording for this voicemail.',
  not_a_voicemail: 'This alert is not a voicemail.',
  not_configured: 'Playback is not configured yet.',
  upstream: 'Could not reach Twilio. Try again.',
  store_unavailable: 'The agent database is unreachable. Try again shortly.',
};
export function playErrorText(code) {
  return PLAY_ERRORS[code] || 'Could not load the recording. Try again.';
}
